// extracted by mini-css-extract-plugin
export default {"benefits":"inY9Q","blocks":"X3_Z_","benefitBlock":"y2EsA","benefitTitle":"wccid","itPrivilegesText":"rAHqu","icon":"VXDqT"};